/**
 * Initialize Capacitor native plugins (StatusBar, SplashScreen).
 * No-ops safely on web — Capacitor.isNativePlatform() returns false.
 */
import { Capacitor } from '@capacitor/core';

export const initCapacitor = async () => {
  if (!Capacitor.isNativePlatform()) return;

  try {
    const { StatusBar, Style } = await import('@capacitor/status-bar');
    await StatusBar.setStyle({ style: Style.Light }); // light icons on dark bg
    await StatusBar.setBackgroundColor({ color: '#1a1a2e' });
    await StatusBar.setOverlaysWebView({ overlay: false });
  } catch (e) {
    console.warn('[capacitor] status-bar init failed:', e);
  }

  try {
    const { SplashScreen } = await import('@capacitor/splash-screen');
    // Give the app a moment to render, then hide splash
    setTimeout(() => SplashScreen.hide().catch(() => {}), 1000);
  } catch (e) {
    console.warn('[capacitor] splash-screen init failed:', e);
  }
};
